import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startModifyForm } from '../../../redux/actions/form';
import { Typography, Box } from '@material-ui/core';
import { ActionBar } from '../../../components/toolbars/ActionBar';
import { ProgressBlock } from '../../../components/blocks/ProgressBlock';
import { SafeSevenInput } from '../../../components/inputs/SafeSevenInput';
import {useLanguage} from "../../../hooks/useLanguage";
import {FORM_TYPES, getStepData} from "../../../enums/Steps";

export const Safe7Four = (props) => {
  const form = useSelector((state) => state.form[0]);
  const dispatch = useDispatch();
  const { t } = useLanguage();

  const handleSafeSevenSelect = (value) => {
    dispatch(startModifyForm({ ...form, safeSevenFour: value }));
  };

  const step = 'safe-4';

  const [validation, setValidation] = useState(false);
  const validate = () => {
    setValidation(true);
  };

  const actionBarCopy = t('4_of_7');
  // const translatedActionBarCopy = actionBarCopy === '4_of_7' ? "4 of 7" : actionBarCopy

  return (
    <React.Fragment>
      <ProgressBlock value1={100} value2={57} />
      <div className={'inner-form-container'}>
        <Box my={4}>
          <Typography variant={'h5'} align={'center'} className={'blue-font'}>
            <strong>{t('survey_question_4')}</strong>
          </Typography>
        </Box>
        <Box my={4}>
          <div className="safe7-graphic safe7-graphic-4"></div>
        </Box>
        <SafeSevenInput selected={form.safeSevenFour} handleSelect={handleSafeSevenSelect} validation={validation} />
      </div>
      <ActionBar
        prevState={'safe-3'}
        handleValidation={validate}
        copy={actionBarCopy}
        // copy={'4 of 7'}
        nextState={form.safeSevenFour ? 'safe-5' : ''}
      />
    </React.Fragment>
  );
};
